export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ad995527-778d-455b-8add-6bfbd3a1f87f';
export const MODAL_CLOSE_SEC = 2.5;